module.exports = __webpack_public_path__ + "img/case-mettler.7ca32c64.png";